module.exports = __webpack_public_path__ + "static/media/download-icon-gray.a8c5e77a.svg";